import React, { useState } from 'react';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    education: '',
    stream: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert(data.message);
        setFormData({ name: '', email: '', phone: '', country: '', education: '', stream: '', message: '' });
      } else {
        alert('Thank you! Your enquiry has been received. We will contact you within 24 hours.');
        setFormData({ name: '', email: '', phone: '', country: '', education: '', stream: '', message: '' });
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Thank you! Your enquiry has been received. We will contact you within 24 hours.');
      setFormData({ name: '', email: '', phone: '', country: '', education: '', stream: '', message: '' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold border border-blue-200">Get In Touch</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">Ready to Begin Your <span className="text-amber-500">Journey</span>?</h2>
          <p className="text-xl text-gray-600">Contact our admissions team today</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-3xl p-8 mb-8 shadow-xl">
              <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
              <div className="space-y-4">
                <div>
                  <p className="text-amber-300 text-sm mb-1 font-semibold">Phone</p>
                  <p className="text-lg">+1 (519) 500-5823</p>
                </div>
                <div>
                  <p className="text-amber-300 text-sm mb-1 font-semibold">Email</p>
                  <p className="text-lg">info@edunexa.ca</p>
                </div>
                <div>
                  <p className="text-amber-300 text-sm mb-1 font-semibold">Head Office</p>
                  <p className="text-lg">Ontario, Canada</p>
                </div>
                <div>
                  <p className="text-amber-300 text-sm mb-1 font-semibold">Office Hours</p>
                  <p className="text-sm">Monday - Friday: 9:00 AM - 5:00 PM EST</p>
                  <p className="text-sm">Saturday - Sunday: Closed</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-100 to-amber-50 border-2 border-amber-300 rounded-2xl p-6 shadow-md">
              <h4 className="font-bold mb-4 text-gray-900">What Happens Next?</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-amber-600 mr-2 font-bold">✓</span>
                  <span className="text-gray-700">Response within 24 hours</span>
                </li>
                <li className="flex items-start">
                  <span className="text-amber-600 mr-2 font-bold">✓</span>
                  <span className="text-gray-700">Free consultation session</span>
                </li>
                <li className="flex items-start">
                  <span className="text-amber-600 mr-2 font-bold">✓</span>
                  <span className="text-gray-700">Personalized program guidance</span>
                </li>
                <li className="flex items-start">
                  <span className="text-amber-600 mr-2 font-bold">✓</span>
                  <span className="text-gray-700">No obligation to enroll</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <form onSubmit={handleSubmit} className="bg-white rounded-3xl p-8 border-2 border-blue-200 shadow-lg">
              <h3 className="text-2xl font-bold mb-6">Send Us Your Details</h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                      placeholder="your@email.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Phone *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                      placeholder="+1 XXX XXX XXXX"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Country of Residence *</label>
                  <input
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                    placeholder=""
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Current Education Level *</label>
                  <select
                    name="education"
                    value={formData.education}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  >
                    <option value="">Select your level</option>
                    <option value="o-levels">Completed O-Levels</option>
                    <option value="a-levels">Completed A-Levels</option>
                    <option value="high-school">High School Graduate</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Intended Stream *</label>
                  <select
                    name="stream"
                    value={formData.stream}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  >
                    <option value="">Select your stream</option>
                    <option value="science">Science Stream</option>
                    <option value="business">Business Stream</option>
                    <option value="computing">Computing & Engineering</option>
                    <option value="undecided">Not Sure Yet</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Message / Questions</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none resize-none"
                    placeholder="Tell us about your goals..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  data-testid="contact-submit-btn"
                  className="w-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-blue-900 py-4 rounded-lg font-bold text-lg transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Enquiry'}
                </button>

                <p className="text-sm text-gray-600 text-center">
                  By submitting, you agree to be contacted by EduNexa
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
